<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h3>
          API
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="d-flex align-items-center col-10">
        <div class="text-muted text-nowrap">Access Token:</div>
        <sensitive-field ref="access-token" :text="organization.access_token" :readonly="true" class="px-1 ml-2"/>
        <copy-button :value="organization.access_token" @onSuccess="onCopy" :title="'Copy'" class="text-nowrap p-0"/>
      </div>
    </div>
  </div>
</template>

<script>
  import CopyButton from '@/components/common/CopyButton'
  import SensitiveField from '@/components/common/SensitiveField'

  export default {
    metaInfo: {
      title: 'API'
    },
    components: {
      CopyButton,
      SensitiveField
    },
    store: {
      organization: '_common.organization'
    },

    methods: {
      onCopy() {
        this.$refs['access-token'].selectText()
      }
    }
  }
</script>
